import React from "react";
import Select from "react-select";
import { filterTemplate } from '../theme';
import { getSimpleStrikePositionLabel } from '../utils/presetMappings';

const ScreenerFilterControls = ({
  data,
  selectedExpirations,
  setSelectedExpirations,
  selectedTickers,
  setSelectedTickers,
  selectedStrikePositions,
  setSelectedStrikePositions
}) => {
  const expirationOptions = Array.from(
    new Set(data.map(row => row.Expiration))
  ).map(date => ({ value: date, label: date }));

  const tickerOptions = Array.from(
    new Set(data.map(row => row.Ticker))
  ).map(ticker => ({ value: ticker, label: ticker }));

  const strikePositionOptions = Array.from(
    new Set(data.map(row => row["Strike Position"]).filter(val => val !== undefined && val !== null))
  ).sort((a, b) => a - b)
   .map(val => ({ value: val, label: getSimpleStrikePositionLabel(val) }));

  const handleExpirationChange = (selectedOptions) => {
    const selectedValues = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
    setSelectedExpirations(selectedValues);
  };

  const handleTickerChange = (selectedOptions) => {
    const selectedValues = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
    setSelectedTickers(selectedValues);
  };

  const handleStrikePositionChange = (selectedOptions) => {
    const selectedValues = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
    setSelectedStrikePositions(selectedValues);
  };

  // Use the theme's filter template styles
  const customStyles = {
    ...filterTemplate.reactSelectStyles,
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999
    })
  };

  return (
    <div
      className="bg-gray-800 rounded-lg p-4 mb-4"
      style={{
        backgroundColor: '#1f2937', // gray-800 matching simulation settings
        borderRadius: '8px',
        padding: '16px',
        marginBottom: '16px'
      }}
    >
      <div className="flex flex-wrap gap-4">
        <div className="flex-1 min-w-[200px]">
          <label className="block text-xs font-medium text-gray-300 mb-2">
            Filter by Expiration
          </label>
          <Select
            isMulti
            options={expirationOptions}
            value={expirationOptions.filter(opt => selectedExpirations.includes(opt.value))}
            onChange={handleExpirationChange}
            placeholder="Select expiration dates..."
            menuPortalTarget={document.body}
            menuPosition="fixed"
            styles={customStyles}
          />
        </div>

        <div className="flex-1 min-w-[200px]">
          <label className="block text-xs font-medium text-gray-300 mb-2">
            Filter by Ticker
          </label>
          <Select
            isMulti
            options={tickerOptions}
            value={tickerOptions.filter(opt => selectedTickers.includes(opt.value))}
            onChange={handleTickerChange}
            placeholder="Select ticker symbols..."
            menuPortalTarget={document.body}
            menuPosition="fixed"
            styles={customStyles}
          />
        </div>

        <div className="flex-1 min-w-[200px]">
          <label className="block text-xs font-medium text-gray-300 mb-2">
            Filter by Strike Position
          </label>
          <Select
            isMulti
            options={strikePositionOptions}
            value={strikePositionOptions.filter(opt => selectedStrikePositions.includes(opt.value))}
            onChange={handleStrikePositionChange}
            placeholder="Select strike positions..."
            menuPortalTarget={document.body}
            menuPosition="fixed"
            styles={customStyles}
          />
        </div>
      </div>
    </div>
  );
};

export default ScreenerFilterControls;
